/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Step_WorkInputs */

const vi_care_log_step_work = /** @type {(inputs: Care_Log_Step_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công việc`)
};

/**

* @param {Care_Log_Step_WorkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_step_work = /** @type {((inputs?: Care_Log_Step_WorkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Step_WorkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_step_work(inputs)
});